// extracted by mini-css-extract-plugin
export default {"title":"_4519de3a81","bld":"eaf159906b"};